module.exports = __webpack_public_path__ + "img/news.f5c8cbee.jpg";